import React from 'react';

import Home from './pages/Home'

import './global.css'

function App() {
  return (    
    <Home />
  );
}

export default App;
